@let sensor = sensorItem();
<div class="sensor-row">
  <span
    class="activation-dot"
    [class.active]="isActive()"
    [class.inactive]="!isActive()"
    [nbTooltip]="activationTooltip()"
  ></span>
  @if (sensor.label) {
    <div class="name" [nbTooltip]="sensor.label.name">{{ sensor.name }}</div>
  } @else {
    <div class="name">{{ sensor.name }}</div>
  }
  <div class="right-cluster">
    <span class="purpose-chip">{{ sensor.purpose | sensorPurpose }}</span>
    <div class="value-cell">
      @if (lastValue() != null) {
        <b>{{ lastValue() | number: '1.0-2': 'de' }}</b>
      } @else {
        <nb-icon icon="ban" pack="fas"></nb-icon>
      }
    </div>
    <div class="unit-cell">
      {{ sensor.effectiveUnit | sensorUnit }}
    </div>
    @if (isActive() || isSyncBlocked() || showCleanStatus()) {
      <div class="icon-section">
        @if (isSyncBlocked()) {
          <div class="blocked" [nbTooltip]="blockedReasonTooltip[syncBlockedReason()!]">
            <nb-icon pack="fas" icon="unlink"></nb-icon>
          </div>
        } @else if (isActive()) {
          <div [ngClass]="classByStatus[syncStatus()]" [nbTooltip]="tooltipByStatus[syncStatus()]">
            <nb-icon pack="fas" [icon]="iconByStatus[syncStatus()]"></nb-icon>
          </div>
        }
        @if (showCleanStatus()) {
          <div [ngClass]="cleanClassByStatus[cleanStatus()]" [nbTooltip]="cleanTooltipByStatus[cleanStatus()]">
            <nb-icon pack="fas" [icon]="cleanIconByStatus[cleanStatus()]"></nb-icon>
          </div>
        }
      </div>
    }
  </div>
</div>
